/**
 *
 * @file 验证器工具
 * @author author-name(lhb 1301465186@qq.com)
 */

/**
 * 合法身份证号
 * 
 * @param  id
 * @returns {boolean}
 */
export function validateIdentityCard(str) {
  const reg = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/;
  if (!reg.test(str)) {
    return false;
  } else {
    return true;
  }
}
/**
 *
 * @param {String} str
 */
// TODO
// 大小写更改
// 统一validate
export function isvalidUsername(str) {
  // const valid_map = ['admin', 'editor']
  // return valid_map.indexOf(str.trim()) >= 0
  return str != ''
}

/**
 * 合法手机号
 * 
 * @param  phone
 * @returns {boolean}
 */

export function validatePhone(str) {
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  if (!reg.test(str)) {
    return false;
  } else {
    return true;
  }
}

/**
 * 合法座机号
 * 
 * @param  phone
 * @returns {boolean}
 */

export function validaTelandlinePhone(str) {
  const reg = /^(\d3,4|\d{3,4}-)?\d{7,8}$/;
  if (!reg.test(str)) {
    return false;
  } else {
    return true;
  }
}


/**
 * 合法uri
 * 
 * @param {*} textval
 * @returns {boolean}
 */

export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}


/**
 * 小写字母
 * 
 * @param {*} str
 * @returns {boolean}
 */

export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}


/**
 * 大写字母
 * 
 * @param {*} str
 * @returns {boolean}
 */

export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}


/**
 * 大小写字母
 * 
 * @param {*} str
 * @returns {boolean}
 */

export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * 判断文本框中是否包含特殊符号
 * 
 * @param {*} str
 * @returns {boolean}
 */
export function validateCharacter(str) {
  var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
  return pattern.test(str);
}

// export function timer(time,btntxt){
//   if (time > 0) {
//       time--;
//       btntxt = time + "s后重新获取";
//     setTimeout(timer(), 1000);
//    }
//    return btntxt
// }